import { Component } from "react";
import logoBranca from '../../../images/logoBranca.png';
import Constante from "../../../util/Constante";


export default class Header extends Component {
  constante = new Constante();
  render() {
    return <header style={{ height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 10, backgroundColor: this.constante.corPrincipal, }}>
      <div style={{ height: 50, width: 100 }}>
        <img
          alt="Logo branca"
          src={logoBranca}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div>
    </header>
  }
}